import _ from 'lodash';

/**
 * Returns whether or not the response is valid.
 *
 * @param {Object} response - Response.
 * @returns {boolean} True or false.
 */
export function isValidResponse (response) {

    return !_.get(response, ['result', 'error']);
}

/**
 * Returns whether or not responses to all requests in multirequest are success.
 *
 * @param {Object} response - Response.
 * @returns {boolean} True or false.
 */
export function isSuccessMultirequestResponse (response) {

    let {result} = response,
        i = 0,
        j = result.length;

    for (; i < j; i++) {
        if (result[i].error) {
            return false;
        }
    }
    return true;
}




// WEBPACK FOOTER //
// ./src/js/datasources/kaltura/validators/devices.js